<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <wizarMenuProcesos :listaTabsRecibe="listaTabsEnvia" :textoPasoRecibe="textoPaso"></wizarMenuProcesos>
    <b-card style="margin-top: 6rem !important">
      <b-row class="mt-2">
        <b-col
          ><p style="text-align: start; font-size: 12px">
            <strong>FECHA DE RENOVACIÓN: </strong>{{ this.hoy }}
          </p></b-col
        >
        <b-col
          ><p style="text-align: start; font-size: 12px">
            <strong>TOTAL DE REGISTROS A COBRAR: </strong
            >{{ this.renovacionTotalPagadas }}
          </p></b-col
        >
        <b-col
          ><p style="text-align: start; font-size: 12px">
            <strong>TOTAL DE REGISTROS RECHAZADOS: </strong
            >{{ this.renovacionMontoPagadas }}
          </p></b-col
        >
      </b-row>
      <b-row class="mt-2">
        <b-col
          ><p style="text-align: start; font-size: 12px">
            <strong>MONTO DE REGISTROS COBRAR: </strong
            >{{ this.renovacionTotalPagadas }}
          </p></b-col
        >
        <b-col
          ><p style="text-align: start; font-size: 12px">
            <strong>MONTO DE REGISTROS RECHAZADOS: </strong
            >{{ this.renovacionMontoPagadas }}
          </p></b-col
        >
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <b-button
            variant="outline-primary"
            :disabled="loaderDetalle"
            @click="obtenerDatosDetalle()"
          >
            <span v-if="!loaderDetalle">Actualizar</span>
            <span v-else>
              <b-spinner small></b-spinner>
              Actualizando...
            </span>
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="loaderDetalle"
            @click="obtenerValidacionAutomatica()"
          >
            <span v-if="!loaderDetalle">{{textoPasoBtn}}</span>
            <span v-else>
              <b-spinner small></b-spinner>
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="mt-1">
      <b-col cols="12">
        <b-table
          thead-tr-class="columnas"
          :items="datosDetallePlan"
          :fields="fieldsDetallePlan"
          :per-page="registrosPorPaginaDetalle"
          :current-page="paginaActualDetalle"
          responsive
          class="parrafos"
        >
          <template v-slot:cell(montoPagado)="row">
            ${{ row.item.montoPagado | numeroDosDecimales }}
          </template>
          <template v-slot:cell(fechaPago)="row">
            {{ row.item.fechaPago | formatoFecha }}
          </template>
          <template v-slot:cell(descripcionRespuesta)="row">
            <b-badge
              variant="success"
              v-if="row.item.descripcionRespuesta === 'Success'"
            >
              {{ row.item.descripcionRespuesta }}</b-badge
            >
            <b-badge variant="warning" v-else>
              {{ row.item.descripcionRespuesta }}</b-badge
            >
          </template>
          <template v-slot:cell(fechaRenovacion)="row">
            {{ row.item.fechaRenovacion | formatoFecha }}
          </template>
          <template v-slot:cell(fechaRespuesta)="row">
            {{ row.item.fechaRespuesta | formatoFecha }}
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group>
              <b-button
                title="Validar token"
                size="sm"
                variant="outline-success"
                @click="validarToken(row.item.idReferencia)"
                :disabled="row.item.tipoServicio === 1"
                ><em class="fa fa-check-circle-o"></em
              ></b-button>
              <b-button
                title="Eliminar token"
                variant="outline-danger"
                size="sm"
                :disabled="row.item.tipoServicio === 2"
                @click="eliminarToken(row.item.idReferencia)"
              >
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
        <div align="center" v-if="loaderDetalle">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loaderDetalle">
          <b-alert
            v-if="
              datosDetallePlan !== undefined && datosDetallePlan.length === 0
            "
            variant="warning"
            show
            >No hay datos
          </b-alert>
        </b-col>
        <b-col v-if="!loaderDetalle">
          <b-pagination
            v-if="
              datosDetallePlan !== undefined && datosDetallePlan.length > 10
            "
            align="center"
            v-model="paginaActualDetalle"
            :total-rows="datosDetallePlan.length"
            :per-page="registrosPorPaginaDetalle"
            aria-controls="tabla"
          ></b-pagination>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import wizarMenuProcesos from "../../components/wizarMenuProcesos/wizarMenuProcesos.vue";
export default {
  name: "renovacionPortalComercial",
  components: {
    wizarMenuProcesos,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null,
        tipoBusqueda: null,
      },
      datosDetallePlan: [],
      fieldsDetallePlan: [],
      registrosPorPaginaDetalle: 10,
      paginaActualDetalle: 0,
      paginaActualDetalleRenovacion: 0,
      registrosPorPaginaDetalleRenovacion: 10,
      fieldsDetalleRenovacion: [],
      loaderDetalle: false,
      hoy: null,
      renovacionTotalPagadas: 0,
      renovacionMontoPagadas: 0,
      renovacionNoTotalPagadas: 0,
      renovacionNoMontoPagadas: 0,
      loaderBtnAcciones: false,
      listaTabsEnvia: [
        {
          idTabs: 1,
          nombreTabs: "tab1",
          checkTabs: true,
          disabledTabs: false,
          icono: "fa fa-check-circle-o",
        },
        {
          idTabs: 2,
          nombreTabs: "tab2",
          checkTabs: false,
          disabledTabs: true,
          icono: "fa fa-money ",
        },
        {
          idTabs: 3,
          nombreTabs: "tab3",
          checkTabs: false,
          disabledTabs: true,
          icono: "fa fa-envelope-o",
        },
      ],
      textoPaso: "VALIDAR TOKEN",
      textoPasoBtn: "Validar Token",
       procesoAcumulador: 1
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    (this.fieldsDetallePlan = [
      { key: "idPlan", label: "ID PLAN", sortable: true },
      { key: "plan", label: "NOMBRE PLAN", sortable: true },
      //{ key: "numeroPoliza", label: "Poliza", sortable: true },
      {
        key: "fechaInicioVigencia",
        label: "FECHA INICIO VIGENCIA",
        sortable: true,
      },
      { key: "fechaFinVigencia", label: "FECHA FIN VIGENCIA", sortable: true },
      { key: "idTicket", label: "ID TICKET", sortable: true },
      { key: "fechaPago", label: "FECHA DE COMPRA", sortable: true },
      { key: "tipoTarjeta", label: "TIPO TARJETA", sortable: true },
      { key: "montoPagado", label: "MONTO PAGADO ($)", sortable: true },
      { key: "idPaciente", label: "ID PACIENTE", sortable: true },
      { key: "tipoPersona", label: "TIPO DE ASEGURADO", sortable: true },
      { key: "paciente", label: "PACIENTE", sortable: true },
      { key: "correo", label: "CORREO", sortable: true },
      { key: "telefono", label: "TELEFONO", sortable: true },
      { key: "fechaRenovacion", label: "FECHA DE RENOVACION", sortable: true },
      { key: "renovacion", label: "RENOVACION AUTOMATICO", sortable: true },
      { key: "idRenovacion", label: "FOLIO RESPUESTA", sortable: true },
      { key: "tipoServicioM", label: "SERVICIO RESPUESTA", sortable: true },
      { key: "codigoRespuesta", label: "CODIGO RESPUESTA", sortable: true },
      {
        key: "descripcionRespuesta",
        label: "DESCRIPICION RESPUESTA",
        sortable: true,
      },
      { key: "fechaRespuesta", label: "FECHA DE RESPUESTA", sortable: true },
      "Acciones",
    ]),
      (this.hoy = this.$moment(new Date().format("DD-MM-YYYY"))._i);
    this.obtenerDatosDetalle();
  },
  methods: {
    fechaMaxima(event) {
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
    },
    obtenerDatosDetalle() {
      this.loaderDetalle = true;
      /*let fechaActual = this.$moment(new Date().format("YYYY-MM-DD")._i);
      let fechaF = this.$moment(new Date().format("YYYY-MM-DD")._i);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      this.loader = true;*/
      this.datosDetallePlan = [];
      if (this.filtro.tipoBusqueda !== null) {
        this.filtro.tipoBusqueda = this.filtro.tipoBusqueda.toUpperCase();
      } else {
        this.filtro.tipoBusqueda = "";
      }
      let fechaInicial = this.$global.traerFecha(new Date());
      const filtro = {
        fechaInicio: fechaInicial,
        fechaFin: "",
        tipoBusqueda: this.filtro.tipoBusqueda,
      };
      this.$http
        .post(this.$api + "reportes/detalleRenovacionAutomaticaPortal", filtro)
        .then((respuesta) => {
          if (respuesta.data.data) {
            if (respuesta.data.data !== undefined) {
              this.datosDetallePlan = respuesta.data.data;
              var renovacionMap = new Map();
              this.datosDetallePlan.forEach((p) =>
                renovacionMap.set(p.idTicket, p)
              );
              let listaRenovacion = [...renovacionMap.values()];
              this.renovacionTotalPagadas = listaRenovacion.filter(
                (item) => item.descripcionRespuesta === "Success"
              ).length;
              this.renovacionMontoPagadas =
                "$" +
                listaRenovacion
                  .filter((item) => item.descripcionRespuesta === "Success")
                  .map((item) => item.montoPagado)
                  .reduce((prev, curr) => prev + curr, 0);
              this.renovacionNoTotalPagadas = listaRenovacion.filter(
                (item) => item.descripcionRespuesta !== "Success"
              ).length;
              this.renovacionNoMontoPagadas =
                "$" +
                listaRenovacion
                  .filter((item) => item.descripcionRespuesta !== "Success")
                  .map((item) => item.montoPagado)
                  .reduce((prev, curr) => prev + curr, 0);
            }
          }
        })
        .finally(() => {
          this.loaderDetalle = false;
          this.paginaActualDetalle = 0;
        });
    },
    eliminarToken(idReferencia) {
     const mensaje = '¿Está seguro de eliminar el token?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
            this.loaderDetalle = true;
          this.$http.post(this.$api + 'multiva/generar/eliminar?idReferencia=' + idReferencia).then(respuesta => {
                if (respuesta.data.data) {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: respuesta.data.data.codigo+" "+respuesta.data.data.mensaje,
                  });
                }
                            this.obtenerDatosDetalle();
              }
          )
        }
      }).finally(() => {
          this.loaderDetalle = false;
        });
    },
    validarToken(idReferencia){
                  this.loaderDetalle = true;
             this.$http.post(this.$api + 'multiva/generar/validacion?idReferencia=' + idReferencia).then(respuesta => {
                if (respuesta.data.data) {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: respuesta.data.data.codigo+" "+respuesta.data.data.mensaje,
                  });
                  this.obtenerDatosDetalle();
                }
              }
          )
          .finally(() => {
          this.loaderDetalle = false;
        });   
    },
    cambiarProceso(){
      this.procesoAcumulador++;
      if(this.procesoAcumulador === 1){
          this.listaTabsEnvia[0].checkTabs = true;
          this.listaTabsEnvia[1].checkTabs = false;
          this.listaTabsEnvia[2].checkTabs = false;
          this.listaTabsEnvia[0].disabledTabs =false;
          this.listaTabsEnvia[1].disabledTabs =true;
          this.listaTabsEnvia[2].disabledTabs =true;
          this.textoPaso = "VALIDAR TOKEN";
          this.textoPasoBtn = "Validar Token";
      }
      if(this.procesoAcumulador === 2){
          this.listaTabsEnvia[0].checkTabs = false;
          this.listaTabsEnvia[1].checkTabs = true;
          this.listaTabsEnvia[2].checkTabs = false;
          this.listaTabsEnvia[0].disabledTabs =true;
          this.listaTabsEnvia[1].disabledTabs =false;
          this.listaTabsEnvia[2].disabledTabs =true;
          this.textoPaso = "COBRO";
          this.textoPasoBtn = "Cobro";
      }
      if(this.procesoAcumulador === 3){
          this.listaTabsEnvia[0].checkTabs = false;
          this.listaTabsEnvia[1].checkTabs = false;
          this.listaTabsEnvia[2].checkTabs = true;
          this.listaTabsEnvia[0].disabledTabs =true;
          this.listaTabsEnvia[1].disabledTabs =true;
          this.listaTabsEnvia[2].disabledTabs =false;
          this.textoPaso = "ENVIO CERTIFICADOS";
            this.textoPasoBtn = "Envio Certificados";
          this.procesoAcumulador = 0;
      }   
    },
    obtenerValidacionAutomatica(){
      this.datosDetallePlan = [];
      if (this.filtro.tipoBusqueda !== null) {
        this.filtro.tipoBusqueda = this.filtro.tipoBusqueda.toUpperCase();
      } else {
        this.filtro.tipoBusqueda = "";
      }
      let fechaInicial = this.$global.traerFecha(new Date());
      const filtro = {
        fechaInicio: fechaInicial,
        fechaFin: "",
        tipoBusqueda: this.filtro.tipoBusqueda,
      };
         this.loaderDetalle = true;
             this.$http.post(this.$api + 'multiva/validacionAutomaticaToken',filtro).then(respuesta => {
                if (respuesta.data.data) {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: respuesta.data.data.codigo+" "+respuesta.data.data.mensaje,
                  });
                  this.obtenerDatosDetalle();
                  this.cambiarProceso();
                }
              }
          )
          .finally(() => {
          this.loaderDetalle = false;
        });   
    }
  },
};
</script>

<style>
.alert-primary {
    color: #ffffff;
    background-color: #0e6ba9;
    border-color: #b8daff;
    font-size: 18px;
}
</style>
